<template lang="pug">
.l-s_motion-graphics
  school-header(theme="naviabsolute")
  .main
    .main-inner
      .main-text
        .jp-title
          | モーショングラフィックスコース
        .en-title
          | MOTION GRAPHICS
          .en-title-date
            .en-title-date-title
              | COURSE
            .en-title-date-date
              | 完全オンライン
              span.pc ・
              br.sp
              | 月額・定額制
        .lead
          | After Effectsで、
          br
          | 映像クリエイターの
          br.sp
          | プロを目指す
        a.external_link#school_mgc_individual_reservation.school-btn.is-lg.is-red.is-arrow(href="https://forms.vook.vc/vook/form/Untitled7/formperma/j_ZUYsupouuLJMCAAmMyFKrnWMSRPQphIUxLVCF9N6U")
          | オンライン相談会を予約する
      .main-image
        img(:src="require('~/assets/images/school/motion-graphics/main.png')" width="730" height="730")
  //- MEMO: 別内容で再開する可能性があるため、残しておく
  SchoolCampaign(start="2026-10-01T10:00:00" end="2026-10-31T15:00:00")
  Pagenav(current="motiongraphics")
  .about#about
    .about-scroll-text
      | ABOUT
    .about-inner
      .about-text
        h2
          | ABOUT
        .about-text-catch
          | 107項目のカリキュラムと
          br
          | 56の実践課題を通じて
          br
          | プロが認めるスキルを手に入れる
        .about-text-description
          | モーショングラフィックスコースのカリキュラムは、第一線で活躍するクリエイターと共に制作。107項目に及ぶ独自のカリキュラムと56の実践課題を通じて、インフォグラフィックスからロゴモーション、CMまで、プロレベルのスキルが身につけられます。
      .about-movie
        .about-movie-inner
          iframe(src="https://player.vimeo.com/video/773242021?background=1" loading="lazy"  frameborder="0" allowfullscreen="allowfullscreen")
    .about-video.l-container.is-md
      h3
        | 6分でわかる
        br.sp
        | モーショングラフィックス
        br.sp
        | コース
      .about-video-rotate
        | MOTION GRAPHICS COURSE MOVIE
      .about-video-video
        .about-video-video-inner
          iframe(src="https://www.youtube.com/embed/erNNqK3oU9o?si=xSLocdMK2nqRYP7I&rel=0" loading="lazy"  frameborder="0" allowfullscreen="allowfullscreen")
      p
        | モーショングラフィックスコースの特徴をWebサイトよりも深く掘り下げてご紹介します。
  .feature#feature
    .l-container.is-lg
      h2
        | FEATURE
        span 3つの特徴
      .feature-scroll-text.pc
        .text
          | FEATURE
      ul.feature-btn
        li
          a(v-scroll-to="'#feature01'")
            .feature-btn-no
              | 01
            .feature-btn-catch
              | 実践型！
              br
              | 作りながら学べる
            .feature-btn-image
              img(v-lazy="require('~/assets/images/school/motion-graphics/feature01.jpg')" width="360" height="200")
            .feature-btn-caption
              | 独自開発カリキュラム
        li
          a(v-scroll-to="'#feature02'")
            .feature-btn-no
              | 02
            .feature-btn-catch
              | プロのクリエイターに
              br
              | 質問できる！
            .feature-btn-image
              img(v-lazy="require('~/assets/images/school/motion-graphics/feature02.jpg')" width="360" height="200")
            .feature-btn-caption
              | メンター制度
        li
          a(v-scroll-to="'#feature03'")
            .feature-btn-no
              | 03
            .feature-btn-catch
              | ライフスタイルに合わせ
              br
              | 受講可能
            .feature-btn-image
              img(v-lazy="require('~/assets/images/school/motion-graphics/feature03.jpg')" width="360" height="200")
            .feature-btn-caption
              | 完全オンライン形式
    ul.feature-items
      li.feature-item#feature01
        .feature-item-no
          .no
            | 01
        .feature-item-content.l-container.is-lg
          .feature-item-title
            .feature-item-title-no
              | 01
            .feature-item-title-text
              span
                | 実践型！作りながら学べる
              strong
                | 独自開発カリキュラム
          .feature-item-catch
            | 107項目のカリキュラムと56本を超える課題を通じて、プロに必要な知識と技術を習得
          .feature-item-points
            .feature-item-point.is-3column.curriculum
              .is-3column-contents
                .is-3column-contents-ttl
                  | カリキュラムをチラッとご紹介
                .is-3column-contents-description
                  | プロ監修の独自開発カリキュラムでは、基礎から専門的な知識に至るまで、必要な知識を学ぶことができます。
                  br
                  | 映像知識やテクニックについてはもちろん、企画書や見積書・契約書の作り方など、プロのクリエイターとして活躍する際に役立つ実践的な知識を習得できます。
                  br
                  | カリキュラムのほんの一部ですが、見ていただいた方がイメージしやすいかと思いますので、ご紹介させていただきます。
                  br
                  | 今回紹介している章では、Illustratorで作成したロゴを、After Effectsでどのように動きをつけていくかを学習できます。
                .curriculum-wrapper
                  .curriculum-item
                    .curriculum-item-ttl 実際に作る映像
                    .curriculum-item-content
                      .video
                        iframe(src="https://player.vimeo.com/video/936234610?badge=0&background=1&autopause=false&quality=540p" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
                  .curriculum-item
                    .curriculum-item-ttl
                      | カリキュラム例：Illustratorパート
                    .curriculum-item-content
                      hooper(:settings="hooperSettingsCuriculum" style="height: auto")
                        slide(v-for="n of 9" :key="n")
                          .slide
                            img(:src="require(`~/assets/images/school/motion-graphics/curriculum/ai-${n}.png`)" width="385" height="288")
                        hooper-navigation(slot="hooper-addons")
                        hooper-pagination(slot="hooper-addons")
                  .curriculum-item
                    .curriculum-item-ttl カリキュラム例：After Effectsパート
                    .curriculum-item-content
                      hooper(:settings="hooperSettingsCuriculum" style="height: auto")
                        slide(v-for="n of 7" :key="n")
                          .slide
                            template(v-if="n === 7")
                              img.gif(:class="`gif-${n}`" :src="require(`~/assets/images/school/motion-graphics/curriculum/ae-gif-4.gif`)")
                            template(v-else)
                              img.gif(:class="`gif-${n}`" :src="require(`~/assets/images/school/motion-graphics/curriculum/ae-gif-${n}.gif`)")
                            img(:src="require(`~/assets/images/school/motion-graphics/curriculum/ae-${n}.png`)" width="385" height="288")
                        hooper-navigation(slot="hooper-addons")
                        hooper-pagination(slot="hooper-addons")
            .feature-item-point
              .feature-item-point-text-catch
                | 様々な映像ジャンルから、プロとして必要なスキル・知識を学ぶ
              .feature-item-point-text-description
                | カリキュラムの各章末には実践課題を用意。習得した知識を応用して課題に取り組むことで、確実に実力をつけることができます。
              ul
                li
                  .video
                    .vimeo
                      iframe(src="https://player.vimeo.com/video/773242034?h=8aad9d09a3&background=1&autopause=false&quality=540p" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
                  .title
                    | インフォグラフィックス
                  .description
                    | After Effects基礎 / Illustrator基礎
                li
                  .video
                    .vimeo
                      iframe(src="https://player.vimeo.com/video/773242048?h=4d4dd1320a&background=1&autopause=false&quality=540p" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
                  .title
                    | ロゴモーション
                  .description
                    | After Effects応用 / Illustrator応用
                li
                  .video
                    .vimeo
                      iframe(src="https://player.vimeo.com/video/773242081?h=1dd80d9fe8&background=1&autopause=false&quality=540p" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
                  .title
                    | 架空の15秒CM
                  .description
                    | After Effects応用 / Premiere Pro基礎 / Illustrator基礎 / Photoshop基礎 / 制作知識 / コンテ制作 / オーディオ
                li
                  .video
                    .vimeo
                      iframe(src="https://player.vimeo.com/video/773242095?h=38ee7ced6c&background=1&autopause=false&quality=540p" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
                  .title
                    | ブランディング（動画）
                  .description
                    | After Effects総括 / Illustrator総括
                li
                  .inner
                    .video
                      .vimeo
                        iframe(src="https://player.vimeo.com/video/773242061?h=e88604f250&background=1&autopause=false&quality=540p" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
                  .title
                    | マスター専用
                  .description
                    | After Effects応用 / Illustrator基礎 / Photoshop基礎 / 制作知識 / コンテ制作 / オーディオ / +Challenge（実写合成 / カラコレ / 抽象的表現（アブスクラクト） / 制作効率化)
                li
                  .inner
                    .video
                      .vimeo
                        iframe(src="https://player.vimeo.com/video/773246310?h=af8e48d820&background=1&autopause=false&quality=540p" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
                  .title
                    | マスタープラン Pro専用
                  .description
                    | After Effects応用 / Illustrator基礎 / Photoshop基礎 / 制作知識 / コンテ制作 / オーディオ / +Challenge（実写合成 / カラコレ / 抽象的表現（アブスクラクト） / 制作効率化)
          .feature-master
            h3
              span
                | マスター限定の
                br.sp
                | スペシャルカリキュラム
            .notice
              | ※「マスター限定」は、マスタープラン／マスタープラン Proをご利用の方が対象です。
            dl
              dt
                strong
                  | 仮想クライアントワーク
              dd
                | マスター限定で、擬似的にクライアントワークを体験できる特別課題を用意。
                br
                | Vook school限定で許諾をいただいた企業のサービスや製品PRを想定したテーマを出題。
                br
                | 実際の仕事に最も近い状況で課題に取り組むことが可能です。
                .feature-master-article-card
                  a(:href="`${$urls.vook}/n/6692`")
                    .feature-master-article-card-thumb
                      img(v-lazy="require('~/assets/images/school/motion-graphics/article/virtual-client-work.png')" width="120" height="63")
                    .feature-master-article-card-txt 確実な実践力を身につける。Vook schoolの仮想クライアントワークとは？
            dl
              dt
                strong
                  | ポートフォリオ制作
              dd
                | マスター限定で、在籍中にメンターのサポートを受けながら、ポートフォリオを制作していただくことが可能です。
                br
                |（マスタープランで最大1本、マスタープラン Proで最大3本制作できます）
                br
                | 「ポートフォリオ」は、ご自身の実力や個性を示す名刺のような役割を果たします。クライアントや企業が作品を拝見し、お仕事をご依頼するかどうかを判断する重要な要素となります。
                .feature-master-article-card
                  a(:href="`${$urls.vook}/n/8048`")
                    .feature-master-article-card-thumb
                      img(v-lazy="require('~/assets/images/school/motion-graphics/article/portfolio.png')" width="120" height="63")
                    .feature-master-article-card-txt 【プロが導く！】メンターサポートで実用的なポートフォリオを制作できるスクール！
            dl
              dt
                strong
                  | 第一線で活躍する
                  br
                  | クリエイターが
                  br
                  | 制作したカリキュラム
                span
                  | ダストマン・白戸裕也が
                  br.pc
                  | Vook schoolだけのために
                  br.pc
                  | カリキュラムを制作。
              dd
                .creator
                  .creator-image
                    img(v-lazy="require('~/assets/images/school/motion-graphics/dustman.jpg')" width="160" height="160")
                    .creator-text
                      .creator-text-title.sp
                        | 映像クリエイター
                      .creator-text-name.sp
                        | ダストマン
                  .creator-text
                    .creator-text-title.pc
                      | 映像クリエイター
                    .creator-text-name.pc
                      | ダストマン
                    .creator-text-description
                      p
                        | 広島の限界集落暮らしの映像屋さん。廃校に事務所を構え、TVやWebのCMをメインにエフェクト・モーショングラフィックス・コンポジット業務を行っている。AfterEffectsのチュートリアルを主に発信しているYouTubeチャンネル『ダストマンTips』を運営。
                      p
                        a(href="https://www.youtube.com/channel/UCDwwZiOLmFWV_YmOgAks5Ug" target="_blank")
                          | YouTubeチャンネル「ダストマンTips」
                .creator
                  .creator-image
                    img(v-lazy="require('~/assets/images/school/motion-graphics/shirato.jpg')" width="160" height="160")
                    .creator-text.sp
                      .creator-text-title
                        | Motion Designer / Editor
                      .creator-text-name
                        | 白戸 裕也
                  .creator-text
                    .creator-text-title.pc
                      | Motion Designer / Editor
                    .creator-text-name.pc
                      | 白戸 裕也
                    .creator-text-description
                      p
                        | 大手制作会社にて、テレビCM・WebCM制作等を経験。2016年よりABEMA、2019年より６秒企画に参加。モーションデザイナーをはじめ、エディター、コンポジターを務める。映像系イベントにも多数登壇、記事も執筆している。
                      p
                        a(href="https://www.sixseconds.co.jp/member/026/" target="_blank")
                          | 6秒企画(サイバーエージェントグループ)所属
      li.feature-item#feature02
        .feature-item-no
          .no
            | 02
        .feature-item-title.l-container.is-lg
          .feature-item-title-no
            | 02
          .feature-item-title-text
            span
              | プロのクリエイターに質問できる！
            strong
              | メンター制度
        .feature-item-description.l-container.is-lg
          | 学習を進める中で分からないことは、いつでも現役クリエイターのメンターに質問することができます。
          br
          | 学習内容に関する質問だけでなく、制作課題のフィードバックやキャリアの相談まで、一人での学びをあらゆる側面でサポートします。
        .feature-item-slides
          hooper(:settings="hooperSettingsFeature02" style="height: auto")
            slide.feature-item-slide(v-for="list in Mentors" :key="list.id")
              .feature-item-slide-thumb
                img(:src="require(`~/assets/images/school/motion-graphics/mentor${list.id}.jpg`)" :alt="`${list.name}`")
                a.external_link#mg-mentor-note1.feature-item-slide-thumb-link.pc(:href="`${$urls.vook}/n/${list.link}`" target="_blank" v-if="list.link")
                  .feature-item-slide-thumb-link-img
                    icon-note-svg
                  .feature-item-slide-thumb-link-text
                    span
                      | メンターのパーソナリティに迫る
                    p
                      | インタビュー記事を読む
              .feature-item-slide-text
                .feature-item-slide-text-inner
                  .feature-item-slide-text-name
                    | {{ list.name }}
                  .feature-item-slide-text-badge
                    .adobe(v-if="list.adobe_expert")
                      img(v-lazy="require('~/assets/images/school/mentors/adobe-community-expert-badge.png')" width="229" height="36")
                    .adobe(v-if="list.adobe_advisor")
                      img(v-lazy="require('~/assets/images/school/mentors/adobe-japan-prerelease-advisor-badge.png')" width="229" height="36")
                  a.external_link#mg-mentor-note1.feature-item-slide-text-link.sp(:href="`${$urls.vook}/n/${list.link}`" target="_blank" v-if="list.link")
                    .feature-item-slide-text-link-img
                      icon-note-svg
                    .feature-item-slide-text-link-text
                      p
                        | インタビュー記事を読む
                  .feature-item-slide-text-description(v-html="list.description")
            hooper-navigation(slot="hooper-addons")
            hooper-pagination(slot="hooper-addons")
      li.feature-item#feature03
        .feature-item-no
          .no
            | 03
        .feature-item-title.l-container.is-lg
          .feature-item-title-no
            | 03
          .feature-item-title-text
            span
              | ライフスタイルに合わせて受講可能
            strong
              | 完全オンライン形式
        .feature-item-description.l-container.is-lg
          .feature-item-description-row
            .feature-item-description-row-text
              | オンライン教材とメンターによるチャットサポート&amp;通話サポートによる完全オンライン形式となっています。
              br
              | PCやスマートフォン、タブレットからいつでも受講できるので、仕事やプライベートと両立しながら、ご自身のライフスタイルに合わせて受講できます。
            .feature-item-description-row-article
              .feature-item-description-row-article-card
                a(:href="`${$urls.vook}/n/6782`")
                  .feature-item-description-row-article-card-thumb
                    img(v-lazy="require('~/assets/images/school/motion-graphics/article/online.png')" width="120" height="63")
                  .feature-item-description-row-article-card-txt 【これなら安心！！】完全オンラインサポートの仕組みを大公開！
        .l-container.is-lg
          .feature-discord
            h3
              | ボイスチャットツール
              br.sp
              | 「Discord」を通して
              br.sp
              | より手軽に、より身近に。
            ul.feature-discord-items
              li
                .feature-discord-item-image
                  img(v-lazy="require('~/assets/images/school/motion-graphics/discord01.jpg')" width="220" height="140")
                .feature-discord-item-text
                  .feature-discord-item-text-title
                    | メンター通話サポート
                  .feature-discord-item-text-description
                    | Vook schoolに在籍しているメンターは、全員が現役のプロクリエイター。開校時間はいつでも繋がる。なんでも聞ける。
              li
                .feature-discord-item-image
                  img(v-lazy="require('~/assets/images/school/motion-graphics/discord02.jpg')" width="220" height="140")
                .feature-discord-item-text
                  .feature-discord-item-text-title
                    | チャットサポート
                  .feature-discord-item-text-description
                    | メンターが常駐していない時でも、気軽にチャットで質問可能。原則、24時間以内にメンターからの返信がきます。
              li
                .feature-discord-item-image
                  img(v-lazy="require('~/assets/images/school/motion-graphics/discord03.jpg')" width="220" height="140")
                .feature-discord-item-text
                  .feature-discord-item-text-title
                    | 作品ギャラリー
                  .feature-discord-item-text-description
                    | 他の生徒さんの映像を見てモチベーションが上がる。同じカリキュラム課題でも、アイディア次第で色々な表現ができちゃう。
              li
                .feature-discord-item-image
                  img(v-lazy="require('~/assets/images/school/motion-graphics/discord04.jpg')" width="220" height="140")
                .feature-discord-item-text
                  .feature-discord-item-text-title
                    | 生徒同士の交流も
                  .feature-discord-item-text-description
                    | 同じ目標に向かって集まったメンバーと繋がることだって簡単。将来チームを組むことだってあるかも。
            .logo
              img(v-lazy="require('~/assets/images/school/motion-graphics/logo-discord.svg')" width="180" height="34.1")
        .feature-discord-table.l-container.is-lg
          h4
            | 営業時間
          table
            tbody
              tr
                th 時間
                th サポート
                th 月
                th 火
                th 水
                th 木
                th 金
                th 土
                th 日
              tr
                td(rowspan="2")
                  p
                    | 10:00 -&nbsp;
                    br.sp
                    | 12:00
                  p
                    | 13:00 -&nbsp;
                    br.sp
                    | 17:00
                td
                  span.pc メンター
                  | 通話
                  span.pc サポート
                td(colspan="6")
                  | 月〜土のいずれか
                  strong
                    | 3日
                    span.is-sm (*)
                    | 実施
                  br
                  span.is-sm
                    | *1) 土・祝日は必ず実施します
                    br
                    | *2) 平日は特定の曜日ではなく週によって実施曜日が異なります
                td 休
              tr
                td
                  | チャット
                  span.pc サポート
                td ○
                td ○
                td ○
                td ○
                td ○
                td ○
                td 休
          p
            | ※年末年始および弊社の定める休日を休業とさせていただく場合がございます。（休業のご案内は随時Discord上にてご案内致します）
  #overallview
  .overallview
    .overallview-inner
      .overallview-scroll-text.pc
        .text
          | OVERALL VIEW
      .l-container.is-lg
        h2
          | OVERALL VIEW
          span モーショングラフィックスコース全体像
        img.pc(:src="require(`~/assets/images/school/motion-graphics/overall-view-pc.png`)" alt="モーショングラフィックス全体像" width="1200" height="579")
        img.sp(:src="require(`~/assets/images/school/motion-graphics/overall-view-sp.png`)" alt="モーショングラフィックス全体像" width="602" height="1861")
  .portfolio-wrap
    Portfolio(current='motiongraphicsPickup')
    .portfolio-wrap-btn
      nuxt-link.school-btn.portfolio-btn(to="/motion-graphics/works")
        strong
          | 作品一覧ページはこちら
  #entry
  conversion-mg
  .voice-videographer
    .voice-videographer-scroll-text.pc
      .text
        | VOICE
    Voice(current="motiongraphics" theme="pickup")
    .voice-wrap
      .voice-wrap-btn
        nuxt-link.school-btn.portfolio-btn(to="/motion-graphics/voice")
          strong
            | 受講生の声一覧ページはこちら
  .career
    .career-scroll-text.pc
      .text
        | CAREER
    h2.l-container.is-lg
      | CAREER
      span 卒業後の進路

    .career-list
      hooper(:settings="hooperSettingsCareer" style="height: auto")
        slide.career-list-item(v-for="list in Careers" :key="list.id")
          .career-list-item-header
            .career-list-item-header-thumb
              img(v-lazy="require(`~/assets/images/school/motion-graphics/career/${list.id}.jpg`)"   :alt="`${list.title}`" width="100" height="100")
            .career-list-item-header-information
              .year
                | {{ list.year }} 卒業生
              .name
                | {{ list.name }}&nbsp;
                span さん
          .career-list-item-body
            .title
              | {{ list.title }}
            .description(v-html="list.description")
            a.external_link#mg-career-note.career-list-item-link(:href="`${$urls.vook}/n/${list.link}`" target="_blank" v-if="list.link")
              .career-list-item-link-img
                icon-note-svg
              .career-list-item-link-text
                span
                  | 卒業生のパーソナリティに迫る
                p
                  | インタビュー記事を読む
        hooper-navigation(slot="hooper-addons")
        hooper-pagination(slot="hooper-addons")

    .l-container.is-lg
      .career-link
        p
          | Vookには、映像業界特化の転職サービス「Vookキャリア」があります。Vook schoolの受講生・卒業生は、Vookキャリアを活用して転職活動を行うことができます。
        .career-link-article-card
          a(:href="`${$urls.vook}/n/7521`")
            .career-link-article-card-thumb
              img(v-lazy="require('~/assets/images/school/motion-graphics/article/career.png')" width="120" height="63")
            .career-link-article-card-txt 【Vook独自の仕組み！】学びから転職まで完全サポートを実現したスクール！！
  .plan#plan
    .l-container.is-lg
      h2
        | PLAN
        span 映像制作をサポートする選べるプラン

      .plan-btn.theme-mg
        ul
          li.theme-master
            a(v-scroll-to="{ el: '#plan3', offset: -70 }")
              .plan-btn-sub
                | 基礎をお試しで学びたい方に
              .plan-btn-ttl
                | エントリープラン
              .plan-btn-price
                .plan-btn-price-row
                  .label 入学金
                  .value.free 無料
                hr.divider
                .plan-btn-price-row
                  .label 月額
                  .value.price
                    span.amount 74,800
                    span.tax 円(税込)〜
          li.theme-master
            a(v-scroll-to="{ el: '#plan1', offset: -70 }")
              .plan-btn-sub
                | 本格的に学ぶなら
              .plan-btn-ttl
                | マスタープラン
              .plan-btn-price
                .plan-btn-price-row
                  .label 入学金
                  .value.price
                    span.amount 139,700
                    span.tax 円(税込)〜
                hr.divider
                .plan-btn-price-row
                  .label 月額
                  .value.price
                    span.amount 39,600
                    span.tax 円(税込)〜
          li.theme-master
            a(v-scroll-to="{ el: '#plan2', offset: -70 }")
              .plan-btn-sub
                | 本気でプロを目指すなら
              .plan-btn-ttl
                | マスタープランPro
              .plan-btn-price
                .plan-btn-price-row
                  .label 入学金
                  .value.price
                    span.amount 198,000
                    span.tax 円(税込)〜
                hr.divider
                .plan-btn-price-row
                  .label 月額
                  .value.price
                    span.amount 39,600
                    span.tax 円(税込)〜
        a.plan-btn-comparison(v-scroll-to="{ el: '#plan-table' }")
          strong 全プラン比較表はこちら
      .plan-detail.theme-mg
        .plan-detail-section#plan1
          .plan-detail-name.theme-master マスタープラン
          .plan-detail-lead
            p
              | Vookがこれまで培ってきた、「プロとして、必要な素養」を順序よく一つの教材として集約しました。
              br
              | After Effectsの基礎から応用までを学ぶことができ、絵コンテから契約書の作り方まで、本格的な映像制作を学ぶ環境を整えています。
              br
              | Vookが選んだ現役のプロクリエイターが、メンターとしてあなたの学習を完全サポートいたします。
          .plan-detail-flex
            .plan-detail-plan
              .plan-detail-ttl プランの特徴
              table
                tbody
                  tr
                    th カリキュラム数
                    td
                      | 90
                      .notice &nbsp;/ 全107
                  tr
                    th ポートフォリオ制作支援
                    td 1作品
                  tr
                    th 受講期間
                    td
                      | 1ヶ月〜
                  tr
                    th その他の特典
                    td
                      ul
                        li
                          | 1年間の在籍期限。
                          br
                          | 受講可能期間中は1ヶ月単位で休学も可能なので、ライフスタイルに合わせて自分のペースで受講が可能です。
                          br
                          .notice ※休学中は費用は発生しません。
                        li マスタープランでのみ受講可能なスペシャルカリキュラム
                        li メンターが卒業まで一貫してサポート
                        li Vookキャリアを活用した就職支援・相談など
            .plan-detail-skill
              .plan-detail-ttl 学べる技術
              ol
                li 90カリキュラムを学ぶことができる
                li ダストマン監修の特別カリキュラムを体験できる
                li メンターのサポートを受けながら、ポートフォリオを制作可能
                li Premiere Pro、Photoshop、Illustratorの基礎的な部分も学習可能
                li 企業協力のもと、仮想でクライアントワークを体験することができる
                  .notice ※最大４回まで参加可能
                li 週3日、音声サポートを実施しており、映像系の内容であればメンターに相談できる

              .plan-article-card
                a(:href="`${$urls.vook}/n/8184`")
                  .plan-article-card-thumb
                    img(v-lazy="require('~/assets/images/school/motion-graphics/article/master.png')" width="120" height="63")
                  .plan-article-card-txt 【After Effectsを仕事に】無駄なく最短で学べるマスタープラン、全貌を一挙公開！

          .plan-detail-price
            .plan-detail-ttl 料金
            .plan-detail-price-flex
              .detail
                .detail-box
                  .detail-box-ttl 入学金
                  .detail-box-price
                    strong 139,700
                    span 円(税込)
                .detail-box
                  .detail-box-ttl 受講料(月額)
                  .detail-box-price
                    strong 39,600
                    span 円(税込)
            .plan-detail-price-notice ※最低受講期間 1ヶ月

        .plan-detail-flex
          .plan-detail-section#plan2
            .plan-detail-name.theme-sub マスタープラン Pro
            .plan-detail-lead.is-sub-lead
              p
                | 映像業界で永続的に仕事をしていきたい、体系的に映像編集を学んで、プロレベルのモーショングラフィックスをご自身で制作したい方へ。
                br
                | Vook schoolが提供する、107のすべてのカリキュラムを履修可能です。
                br
                | さらに、ポートフォリオはメンターのサポートを受けながら最大3本まで制作できるため、プロとして活躍するための強力な武器を磨き上げることができます。
            .plan-detail-plan
              .plan-detail-ttl プランの特徴
              table
                tbody
                  tr
                    th カリキュラム数
                    td
                      | 107
                      .notice &nbsp;/ 全107
                  tr
                    th ポートフォリオ制作支援
                    td 3作品
                  tr
                    th 受講期間
                    td
                      | 1ヶ月〜
            .plan-detail-skill.is-sub-skill
              .plan-detail-ttl 学べる技術
              ol
                li 107カリキュラム全て学ぶことができる
                li ポートフォリオを最大3本まで制作可能
                li Red Giantでリッチな映像制作を体験できる
                li Premiere Pro、Photoshop、Illustratorの基礎的な部分も学習可能
                li 企業協力のもと、仮想でクライアントワークを体験することができる
                  .notice ※最大４回まで参加可能
                li 週3日、音声サポートを実施しており、映像系の内容であればメンターに相談できる
                li メンターが卒業まで一貫してサポート
                li Vookキャリアを活用した就職支援・相談など
              ul

              .plan-article-card
                a(:href="`${$urls.vook}/n/8183`")
                  .plan-article-card-thumb
                    img(v-lazy="require('~/assets/images/school/motion-graphics/article/masterpro.png')" width="120" height="63")
                  .plan-article-card-txt 【本気でプロを目指す】全てのサービスを享受できるマスタープラン Pro、全貌を一挙公開！

            .plan-detail-price
              .plan-detail-ttl 料金
            .plan-detail-price-flex
              .detail
                .detail-box.theme-pro
                  .detail-box-ttl 入学金
                  .detail-box-price.theme-pro
                    strong.theme-pro 198,000
                    span 円(税込)
                .detail-box.theme-pro
                  .detail-box-ttl 受講料(月額)
                  .detail-box-price
                    strong.theme-pro 39,600
                    span 円(税込)
            .plan-detail-price-notice ※最低受講期間 1ヶ月

          .plan-detail-section#plan3
            .plan-detail-name.theme-sub エントリープラン
            .plan-detail-lead.is-sub-lead
              p
                | モーショングラフィックスでの映像編集に挑戦してみたいが、自分が向いているのか不安を感じている方へおすすめのプランです。
                br
                | エントリープランではあるものの、本格的なインフォグラフィックス、ロゴモーション、カメラレイヤーを使った奥行きのある動画などを制作することができます。
            .plan-detail-plan
              .plan-detail-ttl プランの特徴
              table
                tbody
                  tr
                    th カリキュラム数
                    td
                      | 56
                      .notice &nbsp;/ 全107
                  tr
                    th ポートフォリオ制作支援
                    td なし
                  tr
                    th 受講期間
                    td
                      | 1ヶ月〜
            .plan-detail-skill.is-sub-skill
              .plan-detail-ttl 学べる技術
              p
                | After Effectsの基本的な操作方法を学びます。棒グラフの動きをつけるであったり、Illustratorで作成したロゴを実際に動かすなど、基礎とはいいつつも様々な表現を学習できます。

              ul
                li
                  img(v-lazy="require('~/assets/images/school/motion-graphics/skill/1.jpg')" width="132" height="80")
                  strong モーション入門
                li
                  video(src="~/assets/images/school/motion-graphics/skill/2.mp4" autoplay muted loop playsinline)
                  strong インフォグラフィックス
                li
                  video(src="~/assets/images/school/motion-graphics/skill/3.mp4" autoplay muted loop playsinline)
                  strong ロゴモーション
                li
                  video(src="~/assets/images/school/motion-graphics/skill/4.mp4" autoplay muted loop playsinline)
                  strong 架空の15秒CM

              .plan-article-card
                a(:href="`${$urls.vook}/n/8179`")
                  .plan-article-card-thumb
                    img(v-lazy="require('~/assets/images/school/motion-graphics/article/entry.png')" width="120" height="63")
                  .plan-article-card-txt 【初心者にオススメ】基礎から応用まで学べるエントリープラン、その詳細を一挙公開！！

            .plan-detail-price
              .plan-detail-ttl 料金
            .plan-detail-price-flex
              .detail
                .detail-box.theme-pro
                  .detail-box-ttl 受講料(月額)
                  .detail-box-price
                    strong.theme-pro 74,800
                    span 円(税込)
            .plan-detail-price-notice ※最低受講期間 1ヶ月

      #plan-table
      PlanMg

      PlanDiscount

      #plan-curriculum
      .plan-curriculum
        .plan-ttl プランごとの受講可能カリキュラム
        .plan-curriculum-content.theme-mg
          .ttl.theme-master1
            strong マスタープラン Proでは全カリキュラム受講可能
          .ttl.theme-master2
            strong マスタープラン
          .curriculum
            img(v-lazy="require('~/assets/images/school/motion-graphics/skill/1.jpg')" width="80" height="45")
            strong モーション入門
          .curriculum
            video(src="~/assets/images/school/motion-graphics/skill/2.mp4" autoplay muted loop playsinline)
            strong インフォグラフィックス
          .curriculum
            video(src="~/assets/images/school/motion-graphics/skill/3.mp4" autoplay muted loop playsinline)
            strong ロゴモーション
          .curriculum
            video(src="~/assets/images/school/motion-graphics/skill/4.mp4" autoplay muted loop playsinline)
            strong 架空の15秒CM
          .curriculum
            video(src="~/assets/images/school/motion-graphics/skill/5.mp4" autoplay muted loop playsinline)
            strong
              | ブランディング映像
          .curriculum
            video(src="~/assets/images/school/motion-graphics/skill/6.mp4" autoplay muted loop playsinline)
            strong 実写合成
          .curriculum
            video(src="~/assets/images/school/motion-graphics/skill/7.mp4" autoplay muted loop playsinline)
            strong 空間演出
          .ttl.theme-sub
            strong
              | エントリープラン
      .article-items
        .article-item(v-for="list in Articles" :key="list.id")
          .article-item-thumb
            a(:href="`${$urls.vook}/n/${list.link}`" target="_blank" v-if="list.link")
              img(:src="require(`~/assets/images/school/motion-graphics/article/${list.id}.png`)" :alt="`${list.title}`" width="285" height="150")
          .article-item-ttl
            a(:href="`${$urls.vook}/n/${list.link}`" target="_blank" v-if="list.link")
              | {{list.title }}
  conversion-mg
  Flow(current="motiongraphics")
  Faq(current="motiongraphics")
  SchoolCampaign(start="2026-10-01T10:00:00" end="2026-10-31T15:00:00")
  conversion-mg
  Sns
</template>
<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from 'hooper'
import 'hooper/dist/hooper.css'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Meta from '~/assets/mixins/meta'
import SchoolHeader from '~/components/school/Header'
import Portfolio from '~/components/school/Portfolio'
import Voice from '~/components/school/Voice'
import Faq from '~/components/school/Faq'
import Flow from '~/components/school/Flow'
import ConversionMg from '~/components/school/ConversionMg'
import PlanMg from '~/components/school/PlanMg'
import PlanDiscount from '~/components/school/PlanDiscount'
import IconNoteSvg from '~/assets/images/school/motion-graphics/icon-note.svg?inline'
import Careers from '~/assets/json/school/motion-graphics/careers.json'
import Mentors from '~/assets/json/school/motion-graphics/mentors.json'
import Articles from '~/assets/json/school/motion-graphics/articles.json'
import useSession from '~/composables/useSession'
import { felmatLpTag, moshimoLpProc } from '~/libs/affiliate'
import Pagenav from '~/components/school/Pagenav'
import Sns from '~/components/school/Sns'
import SchoolCampaign from '~/components/school/Campaign'
if (process.client) {
  gsap.registerPlugin(ScrollTrigger)
}
export default {
  components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation,
    SchoolHeader,
    Portfolio,
    Voice,
    Faq,
    Flow,
    ConversionMg,
    PlanMg,
    PlanDiscount,
    IconNoteSvg,
    Pagenav,
    Sns,
    SchoolCampaign
  },
  layout: 'school',
  mixins: [Meta],
  data() {
    return {
      isPlanActive: '1',
      meta: {
        title:
          'モーショングラフィックスコース | After Effectsをオンラインで学ぶ',
        description:
          'モーショングラフィックスを無駄なく体系的に学習。オンライン完結・月額定額でAfter Effectsを基礎から応用まで習得し、実案件想定課題でポートフォリオ制作までサポート。未経験から副業・転職を目指す方に最適。',
        image: require('~/assets/images/school/motion-graphics/ogp.png')
      },
      bodyAttrs: {
        class: 'pages-no-option header_no_fixed'
      },
      hooperSettingsCuriculum: {
        wheelControl: false,
        itemsToShow: 1,
        itemsToSlide: 1
      },
      hooperSettingsFeature02: {
        wheelControl: false,
        playSpeed: 2000,
        itemsToShow: 1.1,
        itemsToSlide: 1,
        breakpoints: {
          640: {
            itemsToShow: 2.2
          },
          1600: {
            itemsToShow: 2.5
          }
        }
      },
      hooperSettingsCareer: {
        wheelControl: false,
        playSpeed: 2000,
        itemsToShow: 1.1,
        itemsToSlide: 1,
        breakpoints: {
          640: {
            itemsToShow: 3.2
          },
          1600: {
            itemsToShow: 3.5
          }
        }
      },
      Careers,
      Mentors,
      Articles
    }
  },
  mounted() {
    this.changePlan('1')
    this.sameHight('.is-sub-lead')
    this.sameHight('.is-sub-skill')

    // フェルマアフィリエイトLPタグ
    felmatLpTag()

    // もしもアフィリエイトLP処理
    const rdCode = this.$route.query.rd_code
    if (rdCode) {
      moshimoLpProc(this.$axios, rdCode, useSession().sessionId)
    }
  },
  beforeDestroy() {
    ScrollTrigger.getAll().forEach((t) => {
      t.kill()
    })
  },
  methods: {
    zeroPadding(num) {
      if (num < 10) {
        num = '0' + num
      }
      return num
    },
    changePlan(num) {
      if (num === '1') {
        this.isPlanActive = '1'
      } else {
        this.isPlanActive = '2'
      }
    },
    sameHight(item) {
      // コンテンツの高さを揃える
      const target = document.querySelectorAll(item)
      const heightlist = []
      target.forEach((element) => {
        const height = element.clientHeight
        heightlist.push(height)
      })

      const maxHeight = Math.max.apply(null, heightlist)
      target.forEach((element) => {
        element.style.height = maxHeight + 'px'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/individual/school/school2023.scss';
@import '~/assets/css/individual/school/plan.scss';
$gradation-text-start: #475cb8;
$gradation-text-end: #5cc9dc;
::v-deep {
  @import '~/assets/css/individual/school/school2023-hooper.scss';
}
.l-s_motion-graphics {
  position: relative;
}
.video {
  display: block;
  .vimeo {
    position: relative;
    height: 0;
    padding-top: 56.25%;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
.main {
  position: relative;
  @include media(sp) {
    padding-top: 60px;
  }
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right top, #ea37e1 0%, #7bedf5 100%);
    top: 0;
    left: 0;
    z-index: 1;
  }
  &:after {
    content: '';
    position: absolute;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    top: 20px;
    left: 20px;
    @include media(sp) {
      width: calc(100% - 20px);
      height: calc(100% - 80px);
      top: 70px;
      left: 10px;
    }
    background: linear-gradient(
      to right top,
      #3a119f 0%,
      $gradation-text-end 100%
    );
    z-index: 2;
  }
  &-inner {
    position: relative;
    @include media(pc) {
      max-width: 1360px;
      margin: 0 auto;
      padding-left: 80px;
    }
    @include media(sp) {
      overflow: hidden;
      padding: get_vw(60, 375) get_vw(30, 375);
    }
  }
  &-text {
    @include media(pc) {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    @include media(sp) {
      position: relative;
    }
    z-index: 4;
    color: #fff;
    .jp-title {
      font-size: 28px;
      font-weight: bold;
      letter-spacing: 0.1em;
      margin-bottom: 30px;
      @include media(sp) {
        font-size: 16px;
        margin-bottom: 16px;
      }
    }
    .en-title {
      font-weight: bold;
      letter-spacing: 0.1em;
      margin-bottom: 20px;
      @include media(pc) {
        font-size: 78px;
        line-height: 1.1em;
      }
      @include media(sp) {
        @include media(sp) {
          @include fz_vw(32, 375);
        }
        line-height: 1.2em;
      }
      &-date {
        display: flex;
        align-items: center;
        &-title {
          font-weight: bold;
          @include media(pc) {
            font-size: 78px;
          }
          @include media(sp) {
            @include fz_vw(32, 375);
          }
        }
        &-date {
          letter-spacing: 0.07em;
          @include media(pc) {
            margin-left: 70px;
            padding: 15px 0px;
            font-size: 25px;
          }
          @include media(sp) {
            padding: 7px 0;
            font-size: 14px;
            display: inline-block;
            margin-left: 10px;
          }
          border-top: solid 1px #fff;
          border-bottom: solid 1px #fff;
          line-height: 1em;
        }
      }
    }
    .lead {
      font-size: 32px;
      font-weight: bold;
      line-height: 1.5em;
      letter-spacing: 0.1em;
      @include media(pc) {
        margin-bottom: 30px;
      }
      @include media(sp) {
        font-size: 5vw;
      }
    }
  }
  &-image {
    position: relative;
    z-index: 3;
    text-align: right;
    line-height: 0;
    @include media(pc) {
      padding-top: 80px;
    }
    @include media(sp) {
      position: absolute;
      bottom: 0;
      right: -20%;
    }
    img {
      vertical-align: top;
      @include media(pc) {
        width: 52%;
      }
      @include media(sp) {
        width: 70%;
      }
    }
  }
  .school-btn {
    width: 400px;
    @include media(sp) {
      display: none;
    }
  }
}
.close {
  background: #fff;
  padding: 80px 0 0 0;
  @include media(sp) {
    padding: 40px 0 0 0;
  }
  @include media(pc) {
    font-size: 16px;
  }
  &-message {
    padding: 40px;
    border: solid 4px #ee0000;
    background: rgba(#ee0000, 0.05);
    h3 {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 10px;
      @include media(sp) {
        font-size: 20px;
      }
    }
    @include media(sp) {
      padding: 20px;
    }
  }
}
.about {
  padding: 160px 0 0 0;
  position: relative;
  overflow-x: hidden;
  background: #fff;
  @include media(sp) {
    padding: 40px 0 0 0;
  }
  &-scroll-text {
    @include scroll-text(
      30s,
      80px,
      0s,
      $gradation-text-start,
      $gradation-text-end
    );
  }
  &-inner {
    position: relative;
    @include media(pc) {
      display: flex;
      align-items: center;
      margin-bottom: 80px;
    }
  }
  &-text {
    @include media(pc) {
      flex: 1;
      padding: 0 0 0 max(calc((100vw - 1200px) / 2), 20px);
      margin-right: 100px;
    }
    @include media(sp) {
      padding: 0 10px;
      margin-bottom: 20px;
    }
    h2 {
      margin-bottom: 40px;
      @include media(sp) {
        margin-bottom: 20px;
      }
    }
    &-catch {
      font-size: 24px;
      line-height: 2em;
      font-weight: bold;
      margin-bottom: 40px;
      @include media(sp) {
        font-size: 20px;
        line-height: 1.8em;
        margin-bottom: 24px;
      }
    }
    &-description {
      font-size: 16px;
      line-height: 2.5em;
      @include media(sp) {
        line-height: 1.8em;
      }
    }
  }
  &-movie {
    @include media(pc) {
      width: 55%;
    }
    @include media(sp) {
      padding: 0 10px;
      margin-bottom: 50px;
    }
    &-inner {
      width: 100%;
      height: 0;
      padding-top: 56.25%;
      position: relative;
      iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }
  }
  &-video {
    padding-bottom: 150px;
    &.l-container {
      position: relative;
    }
    @include media(sp) {
      padding-bottom: 50px;
    }
    &-rotate {
      position: absolute;
      top: 195px;
      left: 0px;
      transform: rotate(-90deg);
      color: #999999;
      font-size: 12px;
      transform-origin: center center 0;
      letter-spacing: 0.1em;
      @include media(sp) {
        display: none;
      }
    }
    &-video {
      width: 100%;
      max-width: 700px;
      margin: 0 auto;
      &-inner {
        width: 100%;
        height: 0;
        padding-top: 56.25%;
        position: relative;
        margin: 0 auto;
        iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        &:before {
          content: '';
          width: 110%;
          height: 110%;
          position: absolute;
          background: linear-gradient(
            to right,
            $gradation-text-start 0%,
            $gradation-text-end 100%
          );
          opacity: 0.08;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-15deg);
          @include media(sp) {
            width: 120%;
            height: 120%;
          }
        }
      }
    }
    h3 {
      font-size: 28px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 40px;
      @include media(sp) {
        font-size: 24px;
        margin-bottom: 10px;
      }
    }
    p {
      @include media(pc) {
        text-align: center;
        margin-top: 30px;
        font-size: 20px;
      }
      @include media(sp) {
        margin-top: 20px;
      }
    }
    @include scroll-line(1s, 100px, calc(100% - 120px), 50%, 20px, 80px, 0px);
  }
}
.feature {
  background: #f7f7f7;
  padding: 80px 0 50px;
  position: relative;
  @include media(sp) {
    padding: 50px 0 20px;
  }
  &-scroll-text {
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    .text {
      @include scroll-text(
        40s,
        0,
        0s,
        $gradation-text-start,
        $gradation-text-end
      );
    }
  }
  h2 {
    margin-bottom: 80px;
    @include media(sp) {
      margin-bottom: 20px;
    }
  }
  .feature-btn {
    @include media(pc) {
      display: flex;
      justify-content: space-between;
      padding-bottom: 80px;
    }
    @include media(sp) {
      padding-bottom: 20px;
    }
    li {
      background: #fff;
      @include boxshadow(20px);
      border-radius: 5px;
      position: relative;
      transition: all 0.3s;
      @include media(pc) {
        width: 30%;
        text-align: center;
        &:hover {
          transform: translateY(-5px);
          @include boxshadow(30px, 0.4);
          &:after {
            bottom: 20px;
          }
        }
      }
      @include media(sp) {
        overflow: hidden;
      }
      a {
        display: block;
        cursor: pointer;
        @include media(pc) {
          padding: 60px 0 50px;
        }
        @include media(sp) {
          padding: 10px 30px 10px 140px;
        }
      }
      &:after {
        content: '';
        border-left: solid 2px #71aad8;
        border-bottom: solid 2px #71aad8;
        position: absolute;
        transform: rotate(-45deg);
        transition: all 0.3s;
        @include media(pc) {
          bottom: 30px;
          width: 20px;
          height: 20px;
          left: calc(50% - 10px);
        }
        @include media(sp) {
          width: 16px;
          height: 16px;
          right: 10px;
          top: calc(50% - 10px);
        }
      }
      & + li {
        @include media(sp) {
          margin-top: 10px;
        }
      }
    }
    &-no {
      @include media(pc) {
        letter-spacing: 0.1em;
        font-weight: bold;
        font-size: 72px;
        position: absolute;
        width: 100%;
        text-align: center;
        top: -0.5em;
        left: 0;
      }
      @include media(sp) {
        display: none;
      }
    }
    &-catch {
      @include media(pc) {
        font-size: 18px;
        line-height: 1.5em;
        margin-bottom: 10px;
        font-weight: bold;
      }
      @include media(sp) {
        @include fz_vw(13, 375);
        margin-bottom: 5px;
        line-height: 1.1em;
        color: #707070;
      }
    }
    &-caption {
      font-weight: bold;
      @include media(pc) {
        height: 3em;
        line-height: 1.5em;
        display: flex;
        align-items: center;
        font-size: 24px;
        justify-content: center;
      }
      @include media(sp) {
        @include fz_vw(17, 375);
        line-height: 1.1em;
      }
    }
    &-image {
      @include media(pc) {
        margin-bottom: 10px;
      }
      @include media(sp) {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 130px;
      }
    }
  }
  .feature-items {
    .feature-item {
      padding: 80px 0;
      position: relative;
      @include media(sp) {
        padding: 60px 0;
      }
      &:not(:nth-of-type(1)) {
        border-top: solid 1px #ddd;
      }
      &-no {
        position: absolute;
        height: 100%;
        pointer-events: none;
        top: 0;
        right: 0;
        .no {
          position: sticky;
          @include school-gradation-text(
            0.08,
            $gradation-text-start,
            $gradation-text-end
          );
          font-weight: bold;
          @include media(pc) {
            top: -30px;
            font-size: 520px;
          }
          @include media(sp) {
            top: 20px;
            font-size: 240px;
          }
        }
      }
      &-title {
        display: flex;
        margin-bottom: 40px;
        @include media(sp) {
          margin-bottom: 30px;
          padding: 0 10px;
        }
        &-no {
          width: 80px;
          height: 80px;
          line-height: 80px;
          font-size: 48px;
          text-align: center;
          background: #fff;
          margin-right: 20px;
          font-weight: bold;
          letter-spacing: 0.05em;
          @include media(sp) {
            width: 50px;
            height: 50px;
            line-height: 50px;
            font-size: 24px;
            margin-right: 10px;
          }
        }
        &-text {
          letter-spacing: 0.1em;
          flex: 1;
          span {
            display: block;
            font-weight: bold;
            line-height: 1.5em;
            @include media(sp) {
              font-size: 14px;
              margin-bottom: 5px;
            }
            @include media(pc) {
              font-size: 20px;
              margin-bottom: 10px;
            }
          }
          strong {
            font-size: 32px;
            font-weight: bold;
            @include media(sp) {
              font-size: 24px;
              line-height: 1.1;
            }
          }
        }
      }
      &-catch {
        font-size: 20px;
        font-weight: bold;
        font-weight: 20px;
        line-height: 1.8em;
        margin-bottom: 60px;
        @include media(sp) {
          margin-bottom: 20px;
          padding: 0 10px;
        }
      }
      &-description {
        @include media(pc) {
          font-size: 16px;
          margin-bottom: 50px;
          line-height: 2em;
        }
        @include media(sp) {
          margin-bottom: 20px;
          line-height: 1.8em;
          padding: 0 10px;
        }
        &-row {
          @include media(pc) {
            display: flex;
            justify-content: space-between;
          }
          &-text {
            @include media(pc) {
              width: 49%;
            }
          }
          &-article {
            @include media(pc) {
              width: 46%;
            }
          }
          &-article-card {
            background: #fff;
            @include boxshadow;
            @include media(sp) {
              margin-top: 20px;
            }
            border: solid 1px $light_violet_border;
            a {
              display: flex;
              text-decoration: none;
              padding: 10px;
              @include media(sp) {
                padding: 5px;
              }
            }
            &-thumb {
              width: 35%;
              img {
                width: 100%;
              }
            }
            &-txt {
              flex: 1;
              display: flex;
              align-items: center;
              padding-left: 15px;
              line-height: 1.8;
              font-size: 14px;
              @include media(sp) {
                font-size: 12px;
                line-height: 1.5em;
              }
            }
            &:hover {
              opacity: 0.7;
            }
          }
        }
      }
      &-points {
        .feature-item-point:nth-of-type(2) {
          ul {
            @include media(pc) {
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              margin-top: 30px;
            }
            li {
              @include media(pc) {
                width: 30%;
                margin-bottom: 40px;
              }
              @include media(sp) {
                margin-top: 20px;
              }
              .video {
                margin-bottom: 16px;
                @include media(sp) {
                  margin-bottom: 10px;
                }
              }
              .title {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 10px;
                @include media(sp) {
                  font-size: 16px;
                  margin-bottom: 5px;
                }
              }
              .description {
                font-size: 14px;
                color: #666;
                line-height: 1.5em;
                @include media(sp) {
                  font-size: 13px;
                  margin-bottom: 5px;
                }
              }
            }
          }
        }
      }
      &-point {
        position: relative;
        @include media(sp) {
          margin-top: 40px;
        }
        &-rotate {
          font-size: 12px;
          color: #999999;
          letter-spacing: 0.1em;
          @include media(pc) {
            position: absolute;
            top: 0;
          }
          @include media(sp) {
            margin-bottom: 10px;
          }
        }
        & + .feature-item-point {
          margin-top: 80px;
          @include media(sp) {
            margin-top: 50px;
          }
        }
        &-text {
          &-catch {
            font-size: 24px;
            line-height: 1.5em;
            font-weight: bold;
            margin-bottom: 30px;
            @include media(sp) {
              font-size: 18px;
              margin-bottom: 10px;
            }
          }
          &-description {
            @include media(pc) {
              font-size: 16px;
            }
            @include media(sp) {
              font-size: 15px;
              margin-bottom: 20px;
            }
            line-height: 2;
          }
        }
        &.is-2column {
          @include media(pc) {
            display: flex;
            align-items: center;
          }
          .feature-item-point-text {
            flex: 1;
          }
          .feature-item-point-video {
            @include media(pc) {
              width: 50%;
            }
            video {
              width: 100%;
            }
          }
        }
      }
      .curriculum {
        .is-3column-contents-ttl {
          font-size: 24px;
          font-weight: 600;
          @include media(sp) {
            font-size: 18px;
          }
        }
        .is-3column-contents-description {
          font-size: 16px;
          line-height: 2;
          margin-top: 30px;
          @include media(sp) {
            font-size: 15px;
            margin-top: 10px;
          }
        }
        &-wrapper {
          margin-top: 40px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          @include media(sp) {
            display: block;
            margin-top: 20px;
          }
        }
        &-item {
          width: calc((100% - 40px) / 3);
          @include media(sp) {
            width: 100%;
            margin-bottom: 20px;
            &:nth-child(3) {
              margin-bottom: 0;
            }
          }
        }
        &-item {
          border: 1px solid #ddd;
          &-ttl {
            padding: 15px 10px;
            background: #e6edf7;
            text-align: center;
            font-weight: bold;
            font-size: 1.4em;
            @include media(sp) {
              font-size: 14px;
            }
            &::before {
              content: '▼';
              display: inline-block;
              padding-right: 10px;
              color: $school_mg_primary;
              @include media(sp) {
                padding-right: 5px;
              }
            }
          }
          &-content {
            .video {
              @include video_responsive;
            }
            img {
              width: 100%;
            }
            .slide {
              position: relative;
              .gif {
                position: absolute;
                height: auto;
              }
              .gif-1 {
                width: 15%;
                top: 19%;
                left: 43%;
              }
              .gif-2 {
                width: 16%;
                top: 24.3%;
                left: 1%;
              }
              .gif-3 {
                width: 28%;
                top: 20%;
                left: 29%;
              }
              .gif-4 {
                width: 47%;
                top: 28%;
                left: 30%;
              }
              .gif-5 {
                width: 19%;
                top: 24%;
                left: 3%;
              }
              .gif-6 {
                width: 19%;
                top: 24%;
                left: 2%;
              }
              .gif-7 {
                width: 29%;
                top: 22%;
                left: 35%;
              }
            }
            .hooper-list {
              padding-bottom: unset;
            }
            .hooper-slide {
              padding-right: unset;
            }
            .hooper-navigation {
              // TODO: 枚数決まったら幅調整
              width: calc(20px * 8 + 48px);
              height: 54px;
              padding: 15px;
              margin: 0 auto;
            }
            .hooper-pagination {
              left: 50%;
              bottom: 24px;
              transform: translateX(-50%);
              // TODO: 枚数決まったら幅調整
              width: calc(20px * 8);
              margin: 0 auto;
            }
          }
        }
      }
    }
    #feature02 {
      .feature-item-slides {
        @include media(pc) {
          padding-left: max(calc((100vw - 1200px) / 2), 20px);
        }
        @include media(sp) {
          padding-left: 10px;
        }
      }
      .feature-item {
        cursor: default;
        &-slide {
          display: flex;
          @include media(pc) {
            align-items: flex-end;
          }
          &-thumb {
            position: relative;
            @include media(pc) {
              flex-basis: 40%;
              border: 1px solid #eee;
            }
            @include media(sp) {
              flex-basis: 30%;
              background: #fff;
              padding: 10px 0 0 10px;
            }
            &-link {
              @include media(pc) {
                position: absolute;
                bottom: 7px;
                left: 7px;
                display: flex;
                align-items: center;
                width: calc(100% - 14px);
                padding: 5px 10px 5px 5px;
                background-color: #fff;
                border-radius: 70px;
                text-decoration: none;
                transition: all 0.3s;
                @include boxshadow(20px);
                &:hover {
                  transform: translateY(-3px);
                  @include boxshadow(30px, 0.4);
                }
              }
              &-img {
                @include media(pc) {
                  position: relative;
                  width: 33px;
                  height: 33px;
                  margin-right: 4px;
                  border-radius: 50%;
                  @include school-mg-gradation;
                }
                svg {
                  @include media(pc) {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 19px;
                    height: 15px;
                    fill: none;
                    stroke: #fff;
                    stroke-width: 20px;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  }
                }
              }
              &-text {
                @include media(pc) {
                  span {
                    color: #888;
                    font-size: 10px;
                    line-height: 1.2;
                  }
                  p {
                    margin-top: 1px;
                    color: $gradation-text-start;
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 1.2;
                  }
                }
              }
            }
          }
          &-text {
            @include media(pc) {
              flex-basis: 60%;
              border: 1px solid #eee;
              border-left: none;
            }
            @include media(sp) {
              flex-basis: 70%;
            }
            height: 0;
            padding-top: 65%;
            position: relative;
            background: #fff;
            overflow-x: hidden;
            overflow-y: scroll;
            @include scrollbar_y(4px, #fff, #ccc);
            &-inner {
              position: absolute;
              top: 0;
              left: 0;
              @include media(pc) {
                padding: 25px;
              }
              @include media(sp) {
                padding: 20px 10px;
              }
            }
            &-name {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 30px;
              @include media(sp) {
                font-size: 17px;
                margin-bottom: 20px;
              }
            }
            &-badge {
              .adobe {
                margin-bottom: 34px;
                img {
                  display: block;
                }
              }
            }
            &-link {
              @include media(sp) {
                display: flex;
                align-items: center;
                max-width: 190px;
                margin-bottom: 10px;
                padding: 5px;
                background-color: #fff;
                border: 1px solid $gradation-text-start;
                border-radius: 70px;
                text-decoration: none;
              }
              &-img {
                @include media(sp) {
                  position: relative;
                  width: 25px;
                  height: 25px;
                  margin-right: 2px;
                  border-radius: 50%;
                  @include school-mg-gradation;
                }
                svg {
                  @include media(sp) {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 16px;
                    height: 11px;
                    fill: none;
                    stroke: #fff;
                    stroke-width: 20px;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  }
                }
              }
              &-text {
                @include media(sp) {
                  flex: 1;
                  p {
                    margin-top: 1px;
                    color: $gradation-text-start;
                    font-size: 13px;
                    font-weight: bold;
                    line-height: 1.2;
                  }
                }
              }
            }
            &-description {
              line-height: 2;
              @include media(sp) {
                font-size: 13px;
                line-height: 1.8;
              }
              ::v-deep {
                .subttl {
                  margin-top: 5px;
                  font-weight: 600;
                }
                ul {
                  margin-left: 1.5em;
                  li {
                    list-style: disc;
                    line-height: 1.4;
                    a {
                      display: inline; //リストのデザインが崩れるため指定
                      font-size: 0.9em;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    #feature04 {
      .feature-career {
        &-list {
          @include media(pc) {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          }
        }
        &-item {
          @include media(pc) {
            width: 46%;
            margin-bottom: 40px;
          }
          &-thumb {
            position: relative;
            margin-bottom: 24px;
            @include media(sp) {
              margin-bottom: 20px;
            }
          }
          &-title {
            font-size: 20px;
            font-weight: bold;
            @include media(pc) {
              height: 30px;
              line-height: 38px;
              margin-bottom: 24px;
            }
            @include media(sp) {
              margin-bottom: 16px;
              line-height: 1.1em;
            }
            img {
              height: 30px;
              width: auto;
            }
          }
          &-description {
            line-height: 2em;
            margin-bottom: 24px;
            @include media(sp) {
              margin-bottom: 20px;
            }
          }
          &-link {
            @include media(sp) {
              text-align: center;
            }
            a {
              width: 240px;
            }
          }
        }
        &-item + .feature-career-item {
          margin-top: 40px;
        }
      }
    }
  }
  &-master {
    position: relative;
    background: linear-gradient(
      to right top,
      rgba(71, 92, 184, 0.08) 0%,
      rgba(92, 201, 220, 0.08) 0%
    );
    @include media(pc) {
      margin-top: 80px;
      padding: 50px 30px 0;
    }
    @include media(sp) {
      margin-top: 60px;
      padding: 50px 20px 0;
    }
    border-radius: 10px;
    h3 {
      position: absolute;
      top: -20px;
      font-size: 28px;
      text-align: center;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      @include media(sp) {
        font-size: 20px;
        line-height: 1.4em;
      }
      span {
        font-weight: bold;
        display: inline-block;
        padding-bottom: 18px;
        position: relative;
        &:after {
          width: 100%;
          height: 8px;
          content: '';
          display: block;
          background: linear-gradient(
            to right,
            rgba(52, 86, 186, 0.3) 0%,
            rgba(33, 195, 221, 0.3) 100%
          );
          left: 0;
          bottom: 0;
        }
      }
    }
    .notice {
      @include media(pc) {
        font-size: 16px;
        line-height: 1.5em;
        margin-bottom: 30px;
      }
      @include media(sp) {
        font-size: 14px;
        line-height: 1.4em;
      }
      margin-top: 10px;
      color: #666;
      text-align: center;
    }
    dl {
      @include media(pc) {
        display: flex;
        padding: 30px;
      }
      @include media(sp) {
        padding: 30px 0;
      }
      dt {
        @include media(pc) {
          width: 340px;
          border-right: solid 1px #ccc;
        }
        strong {
          font-weight: bold;
          display: block;
          line-height: 1.5em;
          @include media(pc) {
            font-size: 22px;
          }
          @include media(sp) {
            font-size: 18px;
            margin-bottom: 5px;
          }
        }
        span {
          font-weight: bold;
          display: block;
          line-height: 1.5em;
          color: #666;
          @include media(pc) {
            margin-top: 40px;
            font-size: 18px;
          }
          @include media(sp) {
            margin: 20px 0;
          }
        }
      }
      dd {
        line-height: 2em;
        @include media(pc) {
          flex: 1;
          padding: 0 30px;
        }
        .creator {
          @include media(pc) {
            display: flex;
          }
          &-image {
            @include media(pc) {
              width: 200px;
            }
            @include media(sp) {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
            }
            img {
              @include media(pc) {
                width: 100%;
              }
              @include media(sp) {
                width: 80px;
                margin-right: 16px;
              }
            }
          }
          &-text {
            flex: 1;
            @include media(pc) {
              margin-left: 30px;
            }
            &-text {
              font-size: 13px;
            }
            &-title {
              color: #666;
            }
            &-name {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            &-description {
              p {
                word-wrap: break-word;
                a {
                  padding-left: 1em;
                  position: relative;
                  display: inline-block;
                  &:before {
                    content: '›';
                    position: absolute;
                    left: 0;
                  }
                }
              }
              p + p {
                @include media(pc) {
                  margin-top: 10px;
                }
                @include media(sp) {
                  margin-top: 1em;
                }
              }
            }
          }
        }
        .creator + .creator {
          margin-top: 30px;
          @include media(sp) {
            margin-top: 30px;
          }
        }
      }
    }
    dl + dl {
      border-top: solid 1px #ccc;
    }
    &-article-card {
      background: #fff;
      @include boxshadow;
      border: solid 1px $light_violet_border;
      margin: 20px auto;
      @include media(sp) {
        margin: 10px auto 0px;
      }
      a {
        display: flex;
        text-decoration: none;
        padding: 10px;
        @include media(sp) {
          padding: 5px;
        }
      }
      &-thumb {
        width: 35%;
        img {
          width: 100%;
        }
      }
      &-txt {
        flex: 1;
        display: flex;
        align-items: center;
        padding-left: 15px;
        line-height: 1.8;
        @include media(sp) {
          font-size: 12px;
          line-height: 1.5em;
        }
      }
      &:hover {
        opacity: 0.7;
      }
    }
  }
  &-discord {
    position: relative;
    background: #fff;
    @include media(pc) {
      margin-top: 60px;
      padding: 50px 30px 0;
    }
    @include media(sp) {
      margin-top: 60px;
      padding: 50px 20px 0;
    }
    &.l-container {
      overflow: visible;
    }
    border-radius: 10px;
    h3 {
      position: absolute;
      top: -16px;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      @include media(sp) {
        top: -24px;
        left: 0;
        font-size: 18px;
        line-height: 1.3;
      }
    }
    &-items {
      @include media(pc) {
        display: flex;
        flex-wrap: wrap;
      }
      li {
        flex-basis: 50%;
        @include media(pc) {
          display: flex;
        }
        @include media(sp) {
          padding: 15px 0 20px 0;
          border-bottom: solid 1px #ddd;
        }
        &:nth-child(odd) {
          @include media(pc) {
            padding-right: 40px;
            border-right: solid 1px #ddd;
          }
        }
        &:nth-child(1),
        &:nth-child(2) {
          @include media(pc) {
            border-bottom: solid 1px #ddd;
          }
        }
        &:nth-child(even) {
          @include media(pc) {
            padding-right: 40px;
          }
        }
        .feature-discord-item {
          &-image {
            @include media(pc) {
              width: 220px;
            }
            img {
              width: 100%;
            }
          }
          &-text {
            flex: 1;
            @include media(pc) {
              margin-left: 20px;
            }
            &-title {
              font-size: 18px;
              font-weight: bold;
              letter-spacing: 0.1em;
              margin: 10px 0 10px;
              @include media(sp) {
                font-size: 16px;
              }
            }
            &-description {
              line-height: 2em;
              @include media(sp) {
                line-height: 1.8em;
              }
            }
          }
        }
      }
    }
    .logo {
      padding: 20px 0;
      text-align: center;
      img {
        width: 180px;
      }
    }
  }
  &-discord-table {
    margin-top: 60px;
    h4 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    table {
      position: relative;
      z-index: 1; //背景よりも上に表示
      background: #fff; // thの可読性改善用
      width: 100%;
      margin-bottom: 16px;
      tr {
        th {
          font-weight: bold;
          &:nth-of-type(8) {
            color: $blue;
          }
          &:nth-of-type(9) {
            color: $red;
          }
        }
        th,
        td {
          padding: 18px 30px;
          text-align: center;
          line-height: 1.2em;
          @include media(sp) {
            padding: 8px 5px;
            font-size: 13px;
          }
          // 時間部分のスタイル
          p {
            line-height: 1.2;
            white-space: nowrap;
          }
          p + p {
            margin-top: 10px;
          }
          strong {
            font-weight: bold;
          }
          span.is-sm {
            font-size: 12px;
            display: inline-block;
            margin-top: 5px;
            color: #888;
          }
        }
      }
      tr:first-child {
        background: linear-gradient(
          to right top,
          rgba($gradation-text-start, 0.1) 0%,
          rgba($gradation-text-end, 0.1) 100%
        );
      }
      tr + tr {
        border-top: solid 1px #ddd;
      }
      td {
        background: #fff;
      }
      tr {
        th,
        td {
          border-right: solid 1px #ddd;
        }
        th:nth-last-of-type(1),
        td:nth-last-of-type(1) {
          border-right: none;
        }
      }
    }
  }
}
// アンカーリンク用
#entry {
  padding-top: 70px;
  margin-top: -70px;
}
#overallview {
  padding-top: 120px;
  margin-top: -120px;
}

.overallview {
  position: relative;
  &-scroll-text {
    position: absolute;
    top: -100px;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow-x: hidden;
    .text {
      @include scroll-text(50s, 0px);
    }
  }
  &-inner {
    position: relative;
    background: #fff;
    padding: 130px 0 100px;
    @include media(sp) {
      padding: 80px 0 50px;
    }
  }
  h2 {
    position: absolute;
    margin-top: 0;
    top: -30px;
    @include media(sp) {
      top: -20px;
    }
  }
}
.portfolio {
  &-wrap {
    padding-bottom: 70px;
    @include media(sp) {
      padding-bottom: 50px;
    }
    &-btn {
      text-align: center;
      a {
        @include school-mg-gradation;
        @include media(pc) {
          width: 400px;
        }
        @include media(sp) {
          width: calc(100% - 20px);
        }
        &.school-btn {
          height: 70px;
          padding: 0 5px;
        }
        strong {
          display: block;
          height: 60px;
          margin: 5px 0;
          border-radius: 60px;
          background: #fff;
          color: #000;
          font-size: 19px;
          @include media(pc) {
            padding: 0px 30px;
          }
          @include media(sp) {
            font-size: 18px;
          }
        }
      }
    }
  }
}
.voice-videographer {
  position: relative;
  padding-top: 120px;
  @include media(sp) {
    padding-top: 50px;
  }
  &-scroll-text {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow-x: hidden;
    .text {
      @include scroll-text(50s, 0px);
    }
  }
}
.career {
  position: relative;
  padding: 120px 0 100px;
  background: #fafafa;
  @include media(sp) {
    padding: 50px 0 60px;
  }
  h2 {
    margin-bottom: 60px;
    @include media(sp) {
      margin-bottom: 30px;
    }
  }
  &-scroll-text {
    position: absolute;
    top: -100px;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow-x: hidden;
    .text {
      @include scroll-text(50s, 0px, 0s, #e234ec, #295bcf, scroll_reverse);
    }
  }
  &-list {
    padding-left: max(calc((100vw - 1200px) / 2), 20px);
    @include media(sp) {
      padding-left: 10px;
    }
    &-item {
      flex-grow: 1;
      height: auto;
      position: relative;
      &-header {
        display: flex;
        align-items: flex-end;
        position: absolute;
        top: 0;
        left: 20px;
        z-index: 2;
        &-thumb {
          width: 100px;
          margin-right: 20px;
          margin-right: 20px;
          border: solid 1px #eee;
        }
        &-information {
          flex: 1;
          .year {
            color: #707070;
            font-weight: bold;
            margin-bottom: 8px;
          }
          .name {
            font-size: 20px;
            font-weight: bold;
            padding-bottom: 20px;
            span {
              font-size: 16px;
              font-weight: bold;
            }
          }
        }
      }
      &-body {
        background: #fff;
        height: calc(100% - 20px);
        padding: 100px 20px 90px;
        margin-top: 20px;
        position: relative;
        @include boxshadow(20px);
        .title {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 20px;
          line-height: 1.5em;
        }
        .description {
          p {
            line-height: 1.8em;
          }
          p + p {
            margin-top: 1.8em;
          }
        }
      }
      &-link {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        width: 210px;
        padding: 5px 10px 5px 5px;
        background-color: #fff;
        border: solid 2px #7cbbdb;
        border-radius: 70px;
        text-decoration: none;
        transition: all 0.3s;
        @include boxshadow(20px);
        &:hover {
          transform: translate(-50%, -3px);
          @include boxshadow(30px, 0.4);
        }
        &-img {
          position: relative;
          width: 33px;
          height: 33px;
          margin-right: 4px;
          border-radius: 50%;
          @include school-mg-gradation;
          svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 19px;
            height: 15px;
            fill: none;
            stroke: #fff;
            stroke-width: 20px;
            stroke-linecap: round;
            stroke-linejoin: round;
          }
        }
        &-text {
          span {
            color: #888;
            font-size: 10px;
            line-height: 1.2;
          }
          p {
            margin-top: 1px;
            color: $gradation-text-start;
            font-size: 14px;
            font-weight: bold;
            line-height: 1.2;
          }
        }
      }
    }
  }

  //- TODO：記事数が４つ以上になったら削除　ここから
  &-list.pc {
    @include media(sp) {
      display: none;
    }
    padding-left: 0;
    .l-container {
      display: flex;
      gap: 40px;
    }
    .career-list-item {
      width: 33.3333%;
    }
  }
  //- TODO：記事数が４つ以上になったら削除　ここまで

  &-link {
    margin-top: 30px;
    background: linear-gradient(to right bottom, #f1e0fd 0%, #ebf3fe 100%);
    @include media(pc) {
      align-items: center;
      display: flex;
      gap: 40px;
      padding: 24px;
    }
    @include media(sp) {
      padding: 15px;
      margin-top: 10px;
    }
    p {
      @include media(pc) {
        font-size: 18px;
        width: 50%;
      }
    }
    &-article-card {
      @include media(pc) {
        width: 50%;
      }
      background: #fff;
      @include boxshadow;
      @include media(sp) {
        margin-top: 10px;
      }
      border: solid 1px $light_violet_border;
      a {
        display: flex;
        text-decoration: none;
        padding: 10px;
        @include media(sp) {
          padding: 5px;
        }
      }
      &-thumb {
        width: 35%;
        img {
          width: 100%;
        }
      }
      &-txt {
        flex: 1;
        display: flex;
        align-items: center;
        padding-left: 15px;
        line-height: 1.8;
        font-size: 14px;
        @include media(sp) {
          font-size: 12px;
          line-height: 1.5em;
        }
      }
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
::v-deep {
  .l-s_header {
    @include media(pc) {
      margin-top: 20px;
    }
  }
  #feature02 {
    .hooper-navigation {
      /* TODO: 枚数決まったら幅調整 */
      width: calc(20px * 8 + 48px);
      z-index: 1;
    }
    .hooper-pagination {
      /* TODO: 枚数決まったら幅調整 */
      width: calc(20px * 8);
      z-index: 2;
    }
  }
  .portfolio {
    padding: 70px 0 20px;
    @include media(sp) {
      padding: 50px 0 20px;
    }
  }
  .voice {
    padding-top: 80px;
    padding-bottom: 10px;
    background: linear-gradient(to bottom, #f7f7f7 30px, #fff 30px, #fff 100%);
    @include media(sp) {
      padding-top: 50px;
      padding-bottom: 20px;
      background: linear-gradient(
        to bottom,
        #f7f7f7 20px,
        #fff 20px,
        #fff 100%
      );
    }
    .hooper-navigation {
      width: calc(20px * 6 + 48px);
      z-index: 1;
      margin-top: 20px !important;
      @include media(pc) {
        display: block;
      }
    }
    .hooper-pagination {
      width: calc(20px * 6);
      z-index: 2;
      @include media(pc) {
        display: block;
      }
    }
    &-wrap {
      padding-bottom: 70px;
      background: #fff;
      @include media(sp) {
        padding-bottom: 50px;
      }
      &-btn {
        text-align: center;
        a {
          @include school-mg-gradation;
          @include media(pc) {
            width: 400px;
          }
          @include media(sp) {
            width: calc(100% - 20px);
          }
          &.school-btn {
            height: 70px;
            padding: 0 5px;
          }
          strong {
            display: block;
            height: 60px;
            margin: 5px 0;
            border-radius: 60px;
            background: #fff;
            color: #000;
            font-size: 19px;
            @include media(pc) {
              padding: 0px 30px;
            }
            @include media(sp) {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
  .career {
    &-list {
      &-item {
        &-body {
          p + p {
            margin-top: 1.8em;
          }
        }
      }
    }
    .hooper-list {
      @include media(sp) {
        padding-bottom: 0;
      }
    }
    .hooper-navigation {
      // TODO: 枚数決まったら幅調整
      width: calc(20px * 5 + 48px);
      height: 54px;
      padding: 13px;
      @include media(sp) {
        margin-top: 0px;
      }
    }
    .hooper-pagination {
      bottom: 24px;
      // TODO: 枚数決まったら幅調整
      width: calc(20px * 5);
    }
  }
  .faq {
    padding: 100px 0;
    background: #fff;
    @include media(sp) {
      padding: 50px 0;
    }
  }

  .article {
    &-items {
      padding-top: 90px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-column-gap: 20px;
      -moz-column-gap: 20px;
      column-gap: 20px;
      grid-row-gap: 20px;
      row-gap: 20px;
      @include media(sp) {
        padding: 40px 0;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 10px;
        -moz-column-gap: 10px;
        column-gap: 10px;
        grid-row-gap: 10px;
        row-gap: 10px;
      }
    }
    &-item {
      &-thumb {
        @include hover_thumb();
        @include media(pc) {
          margin-bottom: 10px;
        }
      }
      &-ttl {
        a {
          text-decoration: none;
          line-height: 1.5;
          @include media(sp) {
            font-size: 12px;
          }
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
